// Matches the values the backend actually sends on events[].source (a plain
// string, not a formal enum on their side) — kept here as our own known-values
// list so we can safely map to an icon/label and fall back gracefully if the
// backend ever adds a new source we don't recognize yet.
export const radarSourceEnum = {
  LINKEDIN: "LinkedIn",
  INSTAGRAM: "Instagram",
  FACEBOOK: "Facebook",
  WEB_SEARCH: "Web Search",
  GMAIL: "Gmail",
} as const;

export type RadarSourceKey =
  (typeof radarSourceEnum)[keyof typeof radarSourceEnum];

const KNOWN_SOURCES = new Set<string>(Object.values(radarSourceEnum));

// events[].source is a plain string on the backend, not a formal enum, so we
// only trust values we recognize and fall back to undefined otherwise.
export function toKnownSource(source: string): RadarSourceKey | undefined {
  return KNOWN_SOURCES.has(source) ? (source as RadarSourceKey) : undefined;
}
